import { render, staticRenderFns } from "./FlashMessage.vue?vue&type=template&id=30edcfd0&scoped=true&"
import script from "./FlashMessage.vue?vue&type=script&lang=ts&"
export * from "./FlashMessage.vue?vue&type=script&lang=ts&"
import style0 from "./FlashMessage.vue?vue&type=style&index=0&id=30edcfd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30edcfd0",
  null
  
)

export default component.exports